import React from "react";
import { useAuth } from "./AuthContext";

const ChatContext = React.createContext()

const reducerWrapper = function (cUser) {
   return (state, action) => {
      const { type, payload } = action

      switch (type) {
         case 'CHANGE_USER':
            return {
               chatId: cUser.uid > payload.uid
                  ? cUser.uid + payload.uid : payload.uid + cUser.uid,
               user: payload
            }
         default:
            return state
      }
   }
}

const ChatContextProvider = ({ children }) => {
   const { user } = useAuth()

   const [cChat, dispatch] = React.useReducer(reducerWrapper(user), {
      chatId: null,
      user: {}
   })

   return (
      <ChatContext.Provider value={{ cChat, dispatch }}>
         {children}
      </ChatContext.Provider>
   )
}

const useChat = () => {
   const context = React.useContext(ChatContext)

   if (!context) {
      throw new Error('useAuth should be used inside the ChatContextProvider')
   }

   return context
}

export { ChatContextProvider, useChat }